import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";

import {
  DamageCostEvaluationDamageEditor,
  DamageCostEvaluationDamageEditorProps,
} from "./DamageCostEvaluationDamageEditor";

export interface OwnProps {
  editorProps: DamageCostEvaluationDamageEditorProps;
}

type Props = OwnProps & Omit<AppModalProps, "children">;

export function DamageCostEvaluationDamageEditorModal({ editorProps, ...dialogProps }: Props) {
  const modalStatus = useModalOpenStatus(dialogProps);

  return (
    <AppModal fullWidth maxWidth='xl' {...dialogProps}>
      {(params) => (
        <>
          <AppModalTitle withClose onClose={params.close}>
            Edit local damages
          </AppModalTitle>
          <AppModalContent>
            {modalStatus.isOpen && <DamageCostEvaluationDamageEditor {...editorProps} />}
          </AppModalContent>
        </>
      )}
    </AppModal>
  );
}
